import React, {useEffect, useRef, useState} from "react";
import {DatePicker, LocalizationProvider} from "@mui/lab";
import {Button, FormControlLabel, Stack, Switch, TextField} from "@mui/material";
import {useAuth} from "../../context/AuthContext";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
import ContactPageIcon from '@mui/icons-material/ContactPage';
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
import SummarizeIcon from '@mui/icons-material/Summarize';
import DailyData from "./DailyData";
import useCallDataApi from "../../hooks/data";
import {GridActionsCellItem} from "@mui/x-data-grid";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import ConnectionData from "../orders/ConnectionData";
import {useSnackbar} from "notistack";
import locale from 'date-fns/locale/en-GB'
import MopedIcon from '@mui/icons-material/Moped';
import {format} from "date-fns";
import DeliveryPeriodData from "./DeliverPeriodData";
import {getFormData} from "../../utils/FormUtils";
import PersistentDrawerLeft from "../../components/NewDrawer";
import Loading from "../../components/Loading";
import DinoDialog from "../../components/Dialog";
import {createMap} from "../../utils/NumberUtils";
import {determineAddress, downloadBlob, orderStatusMap} from "../../utils/utils";
import DataGridWithSearch from "../../components/DataGridWithSearch";
import Submenu from "../../components/Submenu";
import HomeRepairServiceRoundedIcon from "@mui/icons-material/HomeRepairServiceRounded";
import QrCodeRoundedIcon from "@mui/icons-material/QrCodeRounded";
import VignetteIcon from "@mui/icons-material/Vignette";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import PrintRoundedIcon from "@mui/icons-material/PrintRounded";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import orderRules from "../orders/orderRules";


const Daily = () => {
    const [orders, setOrders] = useState([])

    const [courierPDFDialog, toggleCourierPDFDialog] = useState(false)
    const [isCourierOrderDialogOpen, toggleCourierOrderDialog] = useState(false);
    const [isDeliveryPeriodDialogOpen, toggleDeliveryPeriodDialog] = useState(false);
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [showClosed, setShowClosed] = useState(false);
    const [tourOffices, setTourOffices] = useState({list: [], obj: {}});
    const [tourGuides, setTourGuides] = useState({list: [], obj: {}});
    const [couriers, setCouriers] = useState([]);
    const [current, setCurrent] = useState(0);
    const [receivers, setReceivers] = useState([]);
    const [transmitters, setTransmitters] = useState([]);
    const [loading, setLoading] = useState(true);

    const {getData: fetchOrders, updateData: editOrder, postData, getBlob, postBlob} = useCallDataApi("orders");
    const {getData: getTourOffices} = useCallDataApi("tour-offices");
    const {getData: getTourGuides} = useCallDataApi("tour-guides");
    const {getData: getCouriers} = useCallDataApi("users")
    const {getData: getTransmitters} = useCallDataApi("transmitters");
    const {getData: getReceivers} = useCallDataApi("receivers");

    const connectionForm = useRef(null);
    const deliveryForm = useRef(null);
    const courierForm = useRef(null);

    const {enqueueSnackbar} = useSnackbar();
    const {getUser} = useAuth()
    const user = getUser()
    const permissions = user?.permissions
    const getCurrentOrder = (id) => orders.find(order => order.id === id)

    useEffect(() => {
        let rd
        try {
            rd = format(selectedDate, 'yyyy-MM-dd')
            setLoading(true)
        } catch (e) {
            return
        }
        postData('daily', {date: rd, show_closed: showClosed})
            .then(o => setOrders(o))
            .finally(() => setLoading(false))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedDate, showClosed])

    useEffect(() => {
        const getData = async () => {
            const [g, o, co, tx, rx] = await Promise.all([
                getTourGuides(),
                getTourOffices(),
                getCouriers('get_couriers'),
                getTransmitters(),
                getReceivers()
            ])
            if (g) setTourGuides({list: g, obj: createMap(g)})
            if (o) setTourOffices({list: o, obj: createMap(o)})
            if (co) setCouriers(co)
            if (tx) setTransmitters(tx)
            if (rx) setReceivers(rx)
        }
        getData()
            .catch(r => console.log(r))
            .finally(() => setLoading(false))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const isSelectedDate = (date) => date === format(selectedDate, 'yyyy-MM-dd')

    const handleSetCourier = () => {
        let formData = getFormData(courierForm.current)
        getPDFForCourier({date: format(new Date(selectedDate), 'yyyy-MM-dd'), ...formData})
    }

    const changeDeliveryPeriod = (data) => {
        editOrder(current, data).then(editedOrder => {
            const editedOrders = orders.map(order => {
                if (current === order.id) return {...order, ...editedOrder}
                return order;
            });
            setOrders(editedOrders)
            enqueueSnackbar('Szerkesztve!', {variant: 'success'})
        })
    }

    const downloadQrCode = (id) => {
        setLoading(true)
        getBlob(`${id}/get_qr_code`, 'png', `QR_CODE_${id}`)
            .then(r => downloadBlob(r, `QR_CODE_${id}`))
            .finally(() => setLoading(false))
    }


    const handleSetDeliveryPeriod = () => {
        let formData = getFormData(deliveryForm.current)
        changeDeliveryPeriod({order: current, ...formData})
    }

    const handleSetCourierForOrder = () => {
        let formData = getFormData(connectionForm.current)
        editOrder(current, formData).then(editedOrder => {
            const editedOrderList = orders.map(order => {
                if (current === order.id) return {...order, ...editedOrder}
                return order;
            });
            setOrders(editedOrderList)
            enqueueSnackbar('Megrendelés szerkesztve!', {variant: 'success'})
        })
    }

    const getPDFForCourier = (data) => {
        postBlob('delivery_pdf', data).then(d => downloadBlob(d, `${data.date}-${data.courier}`))
    }

    const renderWay = (params) => {
        const delivery_d = params.row.actual_delivery_date;
        const return_d = params.row.actual_return_date;
        if (isSelectedDate(delivery_d) && isSelectedDate(return_d)) {
            return <>
                <ArrowCircleRightIcon/><ArrowCircleLeftIcon/>
            </>
        }
        if (isSelectedDate(delivery_d)) return <ArrowCircleRightIcon/>
        if (isSelectedDate(return_d)) return <ArrowCircleLeftIcon/>
    }

    const printZebra = async (id) => {
        fetchOrders(`${id}/get_qr_code_zlp`).then(r => {
            console.log(r)
            const url = `http://${r?.printer_ip}/pstprnt`;

            fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Length': r?.zpl.length.toString(),
                    'Content-Type': 'application/x-www-form-urlencoded' // adjust as necessary
                },
                body: r?.zpl
            })

            fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Length': r?.zpl2.length.toString(),
                    'Content-Type': 'application/x-www-form-urlencoded' // adjust as necessary
                },
                body: r?.zpl2
            })
        })
    }

    const requestDelivery = id => {
        postData(`${id}/request_delivery`, {}).then(editedOrder => {
            const editedOrderList = orders.map(order => {
                if (id === order.id) return {...order, ...editedOrder}
                return order;
            });
            setOrders(editedOrderList)
            enqueueSnackbar('Sikeresen megrendelve!', {variant: 'success'})
        })
    }

    const requestReturn = id => {
        postData(`${id}/request_return`, {}).then(editedOrder => {
            const editedOrderList = orders.map(order => {
                if (id === order.id) return {...order, ...editedOrder}
                return order;
            });
            setOrders(editedOrderList)
            enqueueSnackbar('Sikeresen megrendelve!', {variant: 'success'})
        })
    }

    const downloadLabel = id => {
        postBlob('download_label', {'shipment_id': id}).then(zipFile => downloadBlob(zipFile))
    }

    const columns = [
        {
            field: "manage",
            headerName: "Manage",
            sortable: false,
            type: "actions",
            getActions: (params) => {
                let menu = []

                if (permissions.includes('change_order') && orderRules.canRequestDelivery(params.row)) menu.push(<GridActionsCellItem
                    icon={<ArrowForwardRoundedIcon/>}
                    label="Kiszállítás megrendelése"
                    onClick={() => {
                        requestDelivery(params.row.id)
                    }}
                    showInMenu={true}/>)
                if (permissions.includes('change_order') && orderRules.canRequestReturn(params.row)) menu.push(<GridActionsCellItem
                    icon={<ArrowBackRoundedIcon/>}
                    label="Visszaszállítás megrendelése"
                    onClick={() => {
                        requestReturn(params.row.id)
                    }}
                    showInMenu={true}/>)

                if (permissions.includes('change_order') && orderRules.canSetCourier(params.row)) menu.push(
                    <GridActionsCellItem
                        icon={<ManageAccountsIcon/>}
                        onClick={() => {
                            setCurrent(params.row.id)
                            toggleCourierOrderDialog(true)
                        }}
                        label="Futár beállítása"
                        showInMenu={true}
                    />)


                if ((permissions.includes('view_order') && orderRules.canPrintLabel(params.row)) || permissions.includes('view_tgsuser')) menu.push(
                    <GridActionsCellItem
                        icon={<PrintRoundedIcon/>}
                        onClick={() => {
                            setCurrent(params.row?.id)
                            printZebra(params.row?.id)
                        }}
                        label="Online waybill nyomtatása"
                        showInMenu={true}
                    />)

                // Documents submenu
                const documentItems = [];
                if (permissions.includes('view_waybill')) {
                    documentItems.push({
                        icon: <LocalShippingIcon/>,
                        label: "Szállítólevél",
                        onClick: () => {
                            getBlob(`${params.row.id}/waybill`, 'pdf', params.row['order_number'] + '-waybill')
                                .then(r => downloadBlob(r, params.row['order_number'] + '-waybill'))
                        }
                    });
                }
                if (permissions.includes('view_sticker')) {
                    documentItems.push({
                        icon: <VignetteIcon/>,
                        label: "Matrica",
                        onClick: () => {
                            getBlob(`${params.row.id}/sticker`, 'pdf', params.row['order_number'] + '-sticker')
                                .then(r => downloadBlob(r, params.row['order_number'] + '-sticker'))
                        }
                    });
                }
                if (permissions.includes('view_doublesticker')) {
                    documentItems.push({
                        icon: <VignetteIcon/>,
                        label: "Dupla matrica",
                        onClick: () => {
                            getBlob(`${params.row.id}/double_sticker`, 'pdf', params.row['order_number'] + '-double-sticker')
                                .then(r => downloadBlob(r, params.row['order_number'] + '-double-sticker'))
                        }
                    });
                }
                if (permissions.includes('view_order')) documentItems.push({
                    icon: <QrCodeRoundedIcon/>,
                    onClick: () => {
                        setCurrent(params.row["id"])
                        downloadQrCode(params.row["id"])
                    },
                    label: "QR kód letöltése"
                })
                if (permissions.includes('view_order') && orderRules.canDownloadDelivery(params.row)) documentItems.push({
                    icon: <HomeRepairServiceRoundedIcon/>,
                    onClick: () => {
                        downloadLabel(params.row?.delivery_shipment)
                    },
                    label: "Szállítócímke letöltése"
                })
                if (permissions.includes('view_order') && orderRules.canDownloadReturn(params.row)) documentItems.push({
                    icon: <HomeRepairServiceRoundedIcon/>,
                    onClick: () => {
                        downloadLabel(params.row?.return_shipment)
                    },
                    label: "Visszaszállítócímke letöltése"
                })

                if (documentItems.length > 0) {
                    menu.push(
                        <Submenu
                            key="documents"
                            label="Dokumentumok"
                            items={documentItems}
                            showInMenu={true}
                        />
                    );
                }

                return menu
            },
        },
        {
            field: "way", headerName: "Irány", width: 100,
            renderCell: renderWay,
            valueGetter: (params) => isSelectedDate(params.row['actual_delivery_date']) ? 'Delivery' : 'Return'
        },
        {field: "order_number", headerName: "Rendelés szám", width: 140},
        {field: "comment", headerName: "Megjegyzés", width: 130},
        {field: "internal_comment", headerName: "Belsős megjegyzés", width: 130},
        {field: "status", headerName: "Állapot", width: 230, renderCell: p => orderStatusMap?.[p.row.status], valueGetter: p => p.row.status},
        // {field: "tour_type", headerName: "Program", width: 110},
        {
            field: "tour_office", headerName: "Megrendelő", width: 110, valueGetter: (params) => {
                const to = tourOffices.obj[params.row.tour_office]
                if (to) return to?.name || to?.short_name
                return ''
            }
        },
        {
            field: "tour_guide", headerName: "Csoportkísérő", width: 110, valueGetter: (params) => {
                const tg = tourGuides.obj[params.row.tour_guide]
                if (tg) return `${tg?.last_name} ${tg?.first_name}`
                return ''
            }
        },
        {
            field: "usage_country",
            headerName: "Célország",
            width: 110,
            renderCell: params => params.row?.usage_country ? <img
                src={`https://flagcdn.com/w40/${params.row?.usage_country.toLowerCase()}.png`}
                alt={params.row?.usage_country}
                style={{width: 24, height: 16, marginRight: 8}}
            /> : <p>-</p>
        },
        {field: "delivery_date", type: "date", headerName: "Rendelés dátuma", width: 200},
        {field: "actual_delivery_date", headerName: "Kiszállítási dátum", width: 110},
        {
            field: "delivery_time",
            type: "string",
            headerName: "Kiszállítás idő",
            width: 200,
            renderCell: (params) => params.row.delivery_time_set ? params.row.delivery_time?.slice(0, 5) : params.row.delivery_period,
        },
        {field: "delivery_type", headerName: "Kiszállítás típusa", width: 110},
        {
            field: "delivery_address",
            headerName: "Kiszállítási cím",
            width: 250,
            valueGetter: p => determineAddress(p.row?.delivery_address)
        },
        {field: "delivery_format", headerName: "Csomagolás", width: 110},
        {field: "return_date", type: "date", headerName: "Rendelés vége", width: 200},
        {field: "actual_return_date", headerName: "Visszaszállítási dátum", width: 110},
        {
            field: "return_time",
            type: "string",
            headerName: "Vissza idő",
            width: 200,
            renderCell: (params) => (params.row.return_time?.slice(0, 5) || params.row?.return_period)
        },
        {field: "return_type", headerName: "Visszaszállítás típusa", width: 110},
        {
            field: "return_address",
            headerName: "Vissza cím",
            width: 250,
            valueGetter: p => determineAddress(p.row?.return_address)
        },
        {field: "returned_rx", headerName: "Visszérkezett RX", width: 110},
        {field: "returned_tx", headerName: "Visszaérkezett TX", width: 110},
        {
            field: "receiver",
            headerName: "Vevő",
            width: 110,
            renderCell: (params) => {
                const receiver = receivers.find(r => r.id === params.row.receiver);
                return (
                    <div style={{
                        backgroundColor: receiver?.color,
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                        padding: "0 8px"
                    }}>
                        {receiver?.name}
                    </div>
                );
            }
        },
        {
            field: "transmitter",
            headerName: "Adó",
            width: 110,
            renderCell: (params) => {
                const transmitter = transmitters.find(t => t.id === params.row.transmitter);
                return (
                    <div style={{
                        backgroundColor: transmitter?.color,
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                        padding: "0 8px"
                    }}>
                        {transmitter?.name}
                    </div>
                );
            }
        },
        {field: "order_rx", headerName: "Rendelt RX", width: 110},
        {field: "order_tx", headerName: "Rendelt TX", width: 110},
        {field: "sent_rx", headerName: "Elküldött RX", width: 110},
        {field: "sent_tx", headerName: "Elküldött TX", width: 110},
        {field: "invoice", headerName: "Fizetési mód", width: 110},
        {
            field: "delivery_courier_new",
            headerName: "Kiszállító futár",
            width: 140,
            valueGetter: p => couriers.find(c => c.id === p.row.delivery_courier_new)?.name || '-'
        },
        {
            field: "return_courier_new",
            headerName: "Visszaszállító futár",
            width: 140,
            valueGetter: p => couriers.find(c => c.id === p.row.return_courier_new)?.name || '-'
        },
        {field: "currency", headerName: "Pénznem", width: 110},
        {field: "days", headerName: "Napok száma", type: "number", width: 140},
    ]

    const buttons = orders.length !== 0 ? [
        <Button color='success' endIcon={<ContactPageIcon/>} variant='outlined' onClick={() => toggleCourierPDFDialog(true)}>PDF a futárnak</Button>,
        <Button color='success' endIcon={<SummarizeIcon/>} variant='outlined' onClick={() => {
            const dateString = format(new Date(selectedDate), 'yyyy-MM-dd');
            postBlob('daily_pdf', {date: dateString})
                .then(r => downloadBlob(r, `${dateString}-összes`))
        }}>PDF dátumhoz</Button>,
        <Button color='success' endIcon={<MopedIcon/>} variant='outlined' onClick={() => {
            const dateString = format(new Date(selectedDate), 'yyyy-MM-dd');
            postBlob('daily_hand_pdf', {date: dateString})
                .then(r => downloadBlob(r, `${dateString}-kézbe`))
        }}>PDF csak kézbe</Button>
    ] : []

    return (
        <div style={{height: "100vh"}}>
            <PersistentDrawerLeft title="Kiszállítások" buttons={buttons}>
                <Stack spacing={2} direction='row' marginBottom={2}>
                    <LocalizationProvider dateAdapter={AdapterDateFns} locale={locale}>
                        <DatePicker
                            label="Date"
                            value={selectedDate}
                            mask="____-__-__"
                            inputFormat="yyyy-MM-dd"
                            onChange={newValue => setSelectedDate(newValue)}
                            InputAdornmentProps={{position: 'start'}}
                            renderInput={(params) => <TextField id="date" InputAdornmentProps={{position: 'start'}}
                                                                name="date" {...params} />}
                        />
                    </LocalizationProvider>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={showClosed}
                                onChange={(e) => setShowClosed(e.target.checked)}
                            />
                        }
                        label="Zárt megrendelések mutatása"
                    />
                </Stack>
                <DataGridWithSearch name='daily' rows={orders} columns={columns}/>
                <Loading isLoading={loading}/>

            </PersistentDrawerLeft>
            {/*{orders.length !== 0 && <BasicSpeedDial actions={speedDialActions}/>}*/}

            {/*<AlertDialog*/}
            {/*    onNo={() => (toggleDeleteTourOperatorDialog(false))}*/}
            {/*    onYes={() => {*/}
            {/*        toggleDeleteTourOperatorDialog(false)*/}
            {/*        deleteTourOperator(currentlyDeleted)*/}
            {/*    }*/}
            {/*    }*/}
            {/*    open={isDeleteTourOperatorDialogOpen}*/}
            {/*    title={`Are you sure you want to delete ${getTourGuide(currentlyDeleted)?.name}?`}*/}
            {/*    content={'All things associated with it will be lost.'}/>*/}

            <DinoDialog
                title="PDF generálása futárnak"
                open={courierPDFDialog}
                handleClose={() => (toggleCourierPDFDialog(false))}
                actions={<Stack direction='row' spacing={2} marginRight={2} marginBottom={2}>
                    <Button size='large' variant='outlined'
                            onClick={() => toggleCourierPDFDialog(false)}>Mégsem</Button>
                    <Button size='large' variant='outlined' color='success' onClick={() => {
                        handleSetCourier()
                        toggleCourierPDFDialog(false)
                    }}>Generálás</Button>
                </Stack>}>
                <DailyData reference={courierForm}/>
            </DinoDialog>

            <DinoDialog
                title={`Futár beállítása - ${orders.find(o => o?.id === current)?.order_number || '-'}`}
                open={isCourierOrderDialogOpen}
                handleClose={() => toggleCourierOrderDialog(false)}
                actions={<Stack direction='row' spacing={2} marginRight={2} marginBottom={2}>
                    <Button size='large' variant='outlined'
                            onClick={() => toggleCourierOrderDialog(false)}>Mégsem</Button>
                    <Button size='large' variant='outlined' color='success' onClick={() => {
                        handleSetCourierForOrder()
                        toggleCourierOrderDialog(false)
                    }}>Beállítás</Button>
                </Stack>}>
                <ConnectionData
                    reference={connectionForm}
                    order={orders.find(o => o.id === current)}/>
            </DinoDialog>

            <DinoDialog
                title={`Kiszállítási idő beállítása - ${orders.find(o => o?.id === current)?.order_number || '-'}`}
                open={isDeliveryPeriodDialogOpen}
                handleClose={() => toggleDeliveryPeriodDialog(false)}
                actions={<Stack direction='row' spacing={2} marginRight={2} marginBottom={2}>
                    <Button size='large' variant='outlined'
                            onClick={() => toggleDeliveryPeriodDialog(false)}>Mégsem</Button>
                    <Button size='large' variant='outlined' color='success' onClick={() => {
                        handleSetDeliveryPeriod()
                        toggleDeliveryPeriodDialog(false)
                    }}>Beállítás</Button>
                </Stack>}>
                <DeliveryPeriodData reference={deliveryForm} order={getCurrentOrder(current)}/>
            </DinoDialog>

        </div>
    );
};

export default Daily;
